// removed by extract-text-webpack-plugin
module.exports = {"left-ghost":"positionStyle__left-ghost___2nDjG borderRadiusLeft-m","middle-ghost":"positionStyle__middle-ghost___3cU5S borderRadius-0"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-button/Button/style/positionStyle.css
// module id = 120
// module chunks = 0 2